export const getExtensionFromName = (name = '') => {
    if (!name) {
        return undefined;
    }

    return name.slice((Math.max(0, name.lastIndexOf('.')) || Infinity) + 1);
};
